import {css} from 'lit';

import {defaultStyles} from '../../../components/dialog.js';

export const styles = defaultStyles.extends({
  statics: css``,
});

export default {styles};
